import { render } from "./CustomerFollowDetail.vue?vue&type=template&id=f5196efc&scoped=true"
import script from "./CustomerFollowDetail.vue?vue&type=script&lang=js"
export * from "./CustomerFollowDetail.vue?vue&type=script&lang=js"

import "./CustomerFollowDetail.vue?vue&type=style&index=0&id=f5196efc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5196efc"],['__file',"src/views/qywx/common/partner/customer/CustomerFollowDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5196efc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5196efc', __exports__)) {
    api.reload('f5196efc', __exports__)
  }
  
  module.hot.accept("./CustomerFollowDetail.vue?vue&type=template&id=f5196efc&scoped=true", () => {
    api.rerender('f5196efc', render)
  })

}


export default __exports__